/**
 * Event kuyrugu ve gonderim katmani.
 * Flush kosullari: 5 sn, 20 event, sekme gizlenmesi, sayfadan ayrilma.
 * sendBeacon text/plain ile gonderilir; preflight olusmaz, sayfa kapanirken de calisir.
 */
import log2 from "../../js/log2-lite";

const log = log2("TRACKER_TX");

const FLUSH_INTERVAL_MS = 5000;
const MAX_QUEUE_SIZE = 20;
const MAX_BODY_BYTES = 64 * 1024;
const MAX_EVENTS_PER_BATCH = 50;

class Transport {
    constructor() {
        this.endpoint = null;
        this.contextProvider = null;
        this.queue = [];
        this.timerId = null;
        this.bound = false;
        this.stopped = false;
    }

    init(endpoint, contextProvider) {
        this.endpoint = endpoint;
        this.contextProvider = contextProvider;
        this.bindLifecycle();
        this.startTimer();
    }

    startTimer() {
        if (this.timerId) return;
        const self = this;
        this.timerId = setInterval(function () {
            self.flush("timer");
        }, FLUSH_INTERVAL_MS);
    }

    bindLifecycle() {
        if (this.bound) return;
        this.bound = true;
        const self = this;
        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "hidden") self.flush("hidden");
        });
        window.addEventListener("pagehide", function () {
            self.flush("pagehide");
        });
    }

    enqueue(event) {
        if (this.stopped || !this.endpoint) return;
        this.queue.push(event);
        if (this.queue.length >= MAX_QUEUE_SIZE) this.flush("size");
    }

    /** Kuyrugu bosaltir; gonderim basarisiz olursa event'ler kaybedilir (analitik veri, retry yok). */
    flush(reason) {
        if (!this.endpoint || this.queue.length === 0) return;
        const events = this.queue.splice(0, MAX_EVENTS_PER_BATCH);
        const context = this.contextProvider ? this.contextProvider() : {};
        const payload = Object.assign({}, context, {
            v: 1,
            sentAt: Date.now(),
            events: events,
        });

        let body;
        try {
            body = JSON.stringify(payload);
        } catch (e) {
            log.error("payload serialize failed", e);
            return;
        }

        if (body.length > MAX_BODY_BYTES) {
            // Buyuk props'lar kirpilirsa veri tutarsiz olur; batch'i bolerek gonderiyoruz.
            if (events.length > 1) {
                const half = Math.ceil(events.length / 2);
                this.queue = events.slice(half).concat(this.queue);
                this.sendBatch(Object.assign({}, context, { v: 1, sentAt: Date.now(), events: events.slice(0, half) }));
                return;
            }
            log.warn("event dropped, body too large", events[0] && events[0].name);
            return;
        }

        log.debug("flush", reason, events.length);
        this.send(body);
    }

    sendBatch(payload) {
        try {
            this.send(JSON.stringify(payload));
        } catch (e) {
            log.error("sendBatch failed", e);
        }
    }

    send(body) {
        const url = this.endpoint;
        try {
            if (navigator.sendBeacon) {
                // text/plain: CORS preflight tetiklemez
                const blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
                if (navigator.sendBeacon(url, blob)) return;
            }
        } catch (e) {
            log.debug("sendBeacon failed, falling back to fetch", e);
        }

        try {
            fetch(url, {
                method: "POST",
                body: body,
                keepalive: true,
                mode: "cors",
                credentials: "omit",
                headers: { "Content-Type": "text/plain;charset=UTF-8" },
            }).catch(function () {
                /* analitik veri, sessizce dusurulur */
            });
        } catch (e) {
            log.debug("fetch fallback failed", e);
        }
    }

    stop() {
        this.stopped = true;
        this.queue = [];
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }
}

export const transport = new Transport();
export default transport;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/transport.js
// module id = null
// module chunks = 